import { FC } from 'react';

import cs from 'classnames';

import { FALLBACK_VALUE } from 'constants/uiSettings';

import { ReactComponent as IconNo } from 'assets/icons/circleNo.svg';
import { ReactComponent as IconYes } from 'assets/icons/circleYes.svg';

import styles from './StatusIcon.module.scss';

interface StatusIconProps {
  status: boolean | null | undefined;
  invertColor?: boolean;
  className?: string;
}

const StatusIcon: FC<StatusIconProps> = ({
  status,
  invertColor = false,
  className
}) => {
  if (status === null || status === undefined) {
    return FALLBACK_VALUE;
  }

  const IconComponent = status ? IconYes : IconNo;

  const iconClass = cs(
    styles.icon,
    className,

    {
      [styles.green]: (status && !invertColor) || (!status && invertColor),
      [styles.red]: (!status && !invertColor) || (status && invertColor)
    }
  );

  return <IconComponent className={iconClass} />;
};

export default StatusIcon;
